const style = {
  nameSpan: {
    color: `black`,
    fontSize: `16px`
  },
  span: {
    display: `block`,
    fontSize: `13px`
  },
  spanCenter: {
    textAlign: `center`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/CommunityTable/style/row.js